"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSimplifyBasket = exports.updateOffersPositionInBasket = exports.updateOfferInBasket = exports.updateBasketStatus = exports.updateBasket = exports.unArchiveBasket = exports.startRemovingBasket = exports.startRemoveOfferFromBasket = exports.startRemoveClaimFromBasket = exports.setPagination = exports.setOffersReviewsLinks = exports.setManagers = exports.setClaimToBasket = exports.setBasketsSimplifiedPagination = exports.setBasketsSimplified = exports.setBasketsOrderIDs = exports.setBaskets = exports.setBasketTemplates = exports.setBasket = exports.setActiveBasketsStatus = exports.resetBaskets = exports.removeTempEditBasketData = exports.removeSimplifyBasket = exports.removeOfferFromSimplifyBasket = exports.removeOfferFromBasket = exports.removeClaimFromBasket = exports.removeBasket = exports.moveOfferInBasket = exports.mergeTempEditBasketData = exports.mergeBasketsSimplified = exports.getBasketsSimplified = exports.getBaskets = exports.copyBasketUrlToBuffer = exports.copyBasketToBuffer = exports.archiveBasket = exports.addSimplifyBasket = exports.addOfferToSimplifyBasket = exports.addBasketToClaim = exports.addBasket = void 0;
var _reduxActions = require("redux-actions");
var _createActions = (0, _reduxActions.createActions)({
    getBaskets: function getBaskets(params) {
      return params;
    },
    getBasketsSimplified: function getBasketsSimplified(page, limit, status) {
      return {
        page: page,
        limit: limit,
        status: status
      };
    },
    resetBaskets: function resetBaskets() {
      return undefined;
    },
    updateBasket: function updateBasket(basketID, basket) {
      return {
        basketID: basketID,
        basket: basket
      };
    },
    setBasketsOrderIDs: function setBasketsOrderIDs(basketsIdsList) {
      return basketsIdsList;
    },
    setBaskets: function setBaskets(baskets) {
      return baskets;
    },
    setBasketsSimplified: function setBasketsSimplified(baskets) {
      return baskets;
    },
    mergeBasketsSimplified: function mergeBasketsSimplified(baskets) {
      return baskets;
    },
    addBasket: function addBasket(basket) {
      return basket;
    },
    addBasketToClaim: function addBasketToClaim(basketID, claimID, clientID, callbacks) {
      return {
        basketID: basketID,
        claimID: claimID,
        clientID: clientID,
        callbacks: callbacks
      };
    },
    removeBasket: function removeBasket(basketID) {
      return basketID;
    },
    startRemovingBasket: function startRemovingBasket(basketID) {
      return basketID;
    },
    setBasket: function setBasket(basket) {
      return basket;
    },
    setPagination: function setPagination(pagination) {
      return pagination;
    },
    removeOfferFromBasket: function removeOfferFromBasket(offerID, basketID) {
      return {
        basketID: basketID,
        offerID: offerID
      };
    },
    removeOfferFromSimplifyBasket: function removeOfferFromSimplifyBasket(offerID, basketID) {
      return {
        basketID: basketID,
        offerID: offerID
      };
    },
    addOfferToSimplifyBasket: function addOfferToSimplifyBasket(basketID, offer) {
      return {
        basketID: basketID,
        offer: offer
      };
    },
    updateSimplifyBasket: function updateSimplifyBasket(basketID, basket) {
      return {
        basketID: basketID,
        basket: basket
      };
    },
    removeSimplifyBasket: function removeSimplifyBasket(basketID) {
      return basketID;
    },
    addSimplifyBasket: function addSimplifyBasket(basket) {
      return basket;
    },
    updateOfferInBasket: function updateOfferInBasket(offerID, basketID, offer) {
      return {
        offerID: offerID,
        basketID: basketID,
        offer: offer
      };
    },
    moveOfferInBasket: function moveOfferInBasket(offerKey, nextIndexPosition) {
      return {
        offerKey: offerKey,
        nextIndexPosition: nextIndexPosition
      };
    },
    updateOffersPositionInBasket: function updateOffersPositionInBasket(basketID, newPosition, currentPosition) {
      return {
        basketID: basketID,
        newPosition: newPosition,
        currentPosition: currentPosition
      };
    },
    startRemoveOfferFromBasket: function startRemoveOfferFromBasket(offerID, basketID) {
      return {
        offerID: offerID,
        basketID: basketID
      };
    },
    startRemoveClaimFromBasket: function startRemoveClaimFromBasket(basketID, claimID) {
      return {
        claimID: claimID,
        basketID: basketID
      };
    },
    removeClaimFromBasket: function removeClaimFromBasket(basketID) {
      return basketID;
    },
    setManagers: function setManagers(managers) {
      return managers;
    },
    copyBasketToBuffer: function copyBasketToBuffer(basketID) {
      return basketID;
    },
    copyBasketUrlToBuffer: function copyBasketUrlToBuffer(copyContent) {
      return copyContent;
    },
    setBasketsSimplifiedPagination: function setBasketsSimplifiedPagination(pagination) {
      return pagination;
    },
    archiveBasket: function archiveBasket(basketID) {
      return basketID;
    },
    unArchiveBasket: function unArchiveBasket(basketID) {
      return basketID;
    },
    updateBasketStatus: function updateBasketStatus(basketID, status) {
      return {
        status: status,
        basketID: basketID
      };
    },
    setActiveBasketsStatus: function setActiveBasketsStatus(status) {
      return status;
    },
    mergeTempEditBasketData: function mergeTempEditBasketData(basketID, data) {
      return {
        basketID: basketID,
        data: data
      };
    },
    removeTempEditBasketData: function removeTempEditBasketData(basketID) {
      return basketID;
    },
    setClaimToBasket: function setClaimToBasket(basketID, claim) {
      return {
        basketID: basketID,
        claim: claim
      };
    },
    setOffersReviewsLinks: function setOffersReviewsLinks(links) {
      return links;
    },
    setBasketTemplates: function setBasketTemplates(templates) {
      return templates;
    }
  }, {
    prefix: 'BASKETS'
  }),
  getBaskets = exports.getBaskets = _createActions.getBaskets,
  setBaskets = exports.setBaskets = _createActions.setBaskets,
  setBasketsOrderIDs = exports.setBasketsOrderIDs = _createActions.setBasketsOrderIDs,
  resetBaskets = exports.resetBaskets = _createActions.resetBaskets,
  addBasket = exports.addBasket = _createActions.addBasket,
  addBasketToClaim = exports.addBasketToClaim = _createActions.addBasketToClaim,
  setPagination = exports.setPagination = _createActions.setPagination,
  setBasket = exports.setBasket = _createActions.setBasket,
  removeOfferFromBasket = exports.removeOfferFromBasket = _createActions.removeOfferFromBasket,
  startRemoveOfferFromBasket = exports.startRemoveOfferFromBasket = _createActions.startRemoveOfferFromBasket,
  updateBasket = exports.updateBasket = _createActions.updateBasket,
  setManagers = exports.setManagers = _createActions.setManagers,
  startRemovingBasket = exports.startRemovingBasket = _createActions.startRemovingBasket,
  removeBasket = exports.removeBasket = _createActions.removeBasket,
  updateOfferInBasket = exports.updateOfferInBasket = _createActions.updateOfferInBasket,
  moveOfferInBasket = exports.moveOfferInBasket = _createActions.moveOfferInBasket,
  updateOffersPositionInBasket = exports.updateOffersPositionInBasket = _createActions.updateOffersPositionInBasket,
  copyBasketToBuffer = exports.copyBasketToBuffer = _createActions.copyBasketToBuffer,
  setBasketsSimplified = exports.setBasketsSimplified = _createActions.setBasketsSimplified,
  mergeBasketsSimplified = exports.mergeBasketsSimplified = _createActions.mergeBasketsSimplified,
  getBasketsSimplified = exports.getBasketsSimplified = _createActions.getBasketsSimplified,
  copyBasketUrlToBuffer = exports.copyBasketUrlToBuffer = _createActions.copyBasketUrlToBuffer,
  setBasketsSimplifiedPagination = exports.setBasketsSimplifiedPagination = _createActions.setBasketsSimplifiedPagination,
  archiveBasket = exports.archiveBasket = _createActions.archiveBasket,
  unArchiveBasket = exports.unArchiveBasket = _createActions.unArchiveBasket,
  updateBasketStatus = exports.updateBasketStatus = _createActions.updateBasketStatus,
  setActiveBasketsStatus = exports.setActiveBasketsStatus = _createActions.setActiveBasketsStatus,
  mergeTempEditBasketData = exports.mergeTempEditBasketData = _createActions.mergeTempEditBasketData,
  removeTempEditBasketData = exports.removeTempEditBasketData = _createActions.removeTempEditBasketData,
  startRemoveClaimFromBasket = exports.startRemoveClaimFromBasket = _createActions.startRemoveClaimFromBasket,
  removeClaimFromBasket = exports.removeClaimFromBasket = _createActions.removeClaimFromBasket,
  setClaimToBasket = exports.setClaimToBasket = _createActions.setClaimToBasket,
  removeOfferFromSimplifyBasket = exports.removeOfferFromSimplifyBasket = _createActions.removeOfferFromSimplifyBasket,
  addOfferToSimplifyBasket = exports.addOfferToSimplifyBasket = _createActions.addOfferToSimplifyBasket,
  updateSimplifyBasket = exports.updateSimplifyBasket = _createActions.updateSimplifyBasket,
  removeSimplifyBasket = exports.removeSimplifyBasket = _createActions.removeSimplifyBasket,
  addSimplifyBasket = exports.addSimplifyBasket = _createActions.addSimplifyBasket,
  setOffersReviewsLinks = exports.setOffersReviewsLinks = _createActions.setOffersReviewsLinks,
  setBasketTemplates = exports.setBasketTemplates = _createActions.setBasketTemplates;